// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KlM6","content":"styles_content__2GzeT"};